import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";
import axios from "axios";

const AccountApi = {
	getAccountsByAccounttype(accounttypes) {
		const accountTypeUrl = prependRoot("/account/accountsByAccounttype", getApiRoot());
		return axios.get(accountTypeUrl, {
			params: {
				accounttypes: accounttypes
			}
		},
			{
				headers: {
					'accept': 'application/json'
				}
			}
		);
	},
	getCurrentAccount() {
		const url = prependRoot("/account/getCurrent", getApiRoot());
		return axios.get(url, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	updateTochtBehandelaar(tochtBehandelaarId) {
		const url = prependRoot(`/account/updateTochtBehandelaar/${tochtBehandelaarId}`, getApiRoot());
		return axios.put(url,
			null,
			{
				headers: {
					'accept': 'application/json'
				}
			});
	}
};

export default AccountApi;